import { doc, updateDoc } from "firebase/firestore";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";
import { db } from "../../../lib/firebase";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export const getLuggageTravelItineraryFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const luggage = categorySpecificInfo.luggage;
  if (!isRecord(luggage)) {
    return [];
  }

  const attachments = luggage.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const travelItinerary = attachments.travelItinerary;
  if (!isRecord(travelItinerary) || !Array.isArray(travelItinerary.files)) {
    return [];
  }

  return travelItinerary.files as SmartTagAttachmentFile[];
};

export const withLuggageTravelItineraryFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const luggage = isRecord(categorySpecificInfo.luggage)
    ? categorySpecificInfo.luggage
    : {};
  const attachments = isRecord(luggage.attachments) ? luggage.attachments : {};
  const travelItinerary = isRecord(attachments.travelItinerary)
    ? attachments.travelItinerary
    : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      luggage: {
        ...luggage,
        attachments: {
          ...attachments,
          travelItinerary: {
            ...travelItinerary,
            files,
          },
        },
      },
    },
  };
};

export const persistLuggageTravelItineraryFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const docRef = doc(db, `users/${userId}/vcards/luggage`);
  await updateDoc(docRef, {
    "categorySpecificInfo.luggage.attachments.travelItinerary.files": files,
  });
};
